import { render, staticRenderFns } from "./RichiestaContatto.vue?vue&type=template&id=78b9987c&scoped=true&"
import script from "./RichiestaContatto.vue?vue&type=script&lang=js&"
export * from "./RichiestaContatto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9987c",
  null
  
)

export default component.exports